module.exports = __webpack_public_path__ + "img/Chevron-right-filled.644ba3c3.svg";